import React from 'react';
import { Badge } from '@/components/ui';

interface BadgeCellProps {
  value?: unknown;
  variant?: React.ComponentProps<typeof Badge>['variant'];
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  color?: React.ComponentProps<typeof Badge>['color'];
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  highContrast?: boolean;
  render?: () => React.ReactNode;
}

function BadgeCell({
  value,
  variant = 'surface',
  size = 'small',
  color = 'default',
  startIcon,
  endIcon,
  highContrast,
  render,
}: BadgeCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  if (value === null || value === undefined) {
    return null;
  }

  return (
    <Badge
      variant={variant}
      size={size}
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      highContrast={highContrast}
      className="data-cell__badge"
    >
      {String(value)}
    </Badge>
  );
}

export default BadgeCell;
